import { render } from "./SummerClassFee.vue?vue&type=template&id=22689f3f&scoped=true"
import script from "./SummerClassFee.vue?vue&type=script&lang=js"
export * from "./SummerClassFee.vue?vue&type=script&lang=js"

import "./SummerClassFee.vue?vue&type=style&index=0&id=22689f3f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22689f3f"]])

export default __exports__